import { QUERY_KEYS } from "library/shared";
import { OfferListEntryDto } from "library/types/types";
import {
  UseQueryResult,
  useQuery,
  useQueryClient,
} from "@tanstack/react-query";
import api from "service/api";
import { AxiosError } from "axios";

type Params = {
  offerId: number | string | null;
  enabled?: boolean;
};

const getOffer = async ({ offerId }: Params) => {
  if (!offerId) return;

  const response = await api.get(`/offers/${offerId}`);

  return response.data;
};

export function useGetOffer({
  offerId,
  enabled = true,
}: Params): UseQueryResult<OfferListEntryDto> {
  return useQuery<OfferListEntryDto, Error>({
    queryKey: [QUERY_KEYS.offer, offerId],
    queryFn: () => getOffer({ offerId }),
    enabled: enabled,
    staleTime: 0, // Allow invalidation to work - data becomes stale immediately
    refetchOnMount: true, // Refetch when component remounts (when navigating back)
    refetchOnWindowFocus: false, // Don't refetch when window regains focus
  });
}

export const useInvalidateOffer = () => {
  const queryClient = useQueryClient();

  return () => queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.offer] });
};
export const useRefetchOffer = () => {
  const queryClient = useQueryClient();

  return () => queryClient.refetchQueries({ queryKey: [QUERY_KEYS.offer] });
};
